// extracted by mini-css-extract-plugin
module.exports = {"container":"e_X2","tabList":"e_Y2"};